// Shift header for the Shift Detail panel: "[Mon] [M/D] ∙ [Day/Evening/Night] ∙ [HH:MM–HH:MM]",
// then the unit (medium) and role (light), and the required-qualifications line when present.
import React from 'react';
import { Gap, Text } from '@common/components';
import { spaceTimeRange } from './_schedule-shift-detail-panel-service';

export function ScheduleShiftDetailHeader({
  dayLabel,
  dateLabel,
  bandLabel,
  timeRange,
  unitName,
  role,
  requiredQualifications = [],
}: {
  dayLabel: string;
  dateLabel: string;
  bandLabel: string;
  timeRange: string;
  unitName?: string;
  role: string;
  requiredQualifications?: string[];
}) {
  return (
    <Gap vertical size="xxs" align="start" fullWidth>
      <Text size="md" weight="bold" color="midnightDarkest">
        {dayLabel} {dateLabel} ∙ {bandLabel} ∙ {spaceTimeRange(timeRange)}
      </Text>
      {unitName && (
        <Text size="md" weight="medium" color="midnightRegular">
          {unitName}
        </Text>
      )}
      <Text size="md" color="midnightLighter">
        {role}
      </Text>
      {requiredQualifications.length > 0 && (
        <Text size="md" color="midnightLighter">
          {requiredQualifications.join(', ')} required
        </Text>
      )}
    </Gap>
  );
}
